export const notifications = (
  <svg
    id="notifications_none_24px"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect id="Boundary" width="24" height="24" fill="none" />
    <path
      id="_Color"
      data-name=" ↳Color"
      d="M8,19.5a2,2,0,0,1-2-2h4A2,2,0,0,1,8,19.5Zm8-3H0v-1l2-2v-5A7.086,7.086,0,0,1,3.177,4.44,5.529,5.529,0,0,1,6.5,2.18V1.5a1.5,1.5,0,0,1,3,0V2.18a5.522,5.522,0,0,1,3.326,2.264A7.093,7.093,0,0,1,14,8.5v5l2,2v1ZM8,4A3.717,3.717,0,0,0,5.066,5.32,4.907,4.907,0,0,0,4,8.5v6h8v-6a4.908,4.908,0,0,0-1.066-3.18A3.716,3.716,0,0,0,8,4Z"
      transform="translate(4 2)"
    />
  </svg>
);
